/**
 * @file CloseCompleteAssignmentDialog.jsx
 * @description CloseCompleteAssignmentDialog component for displaying and managing close/complete assignment dialog.
 * @component CloseCompleteAssignmentDialog
 * @exports CloseCompleteAssignmentDialog - Main component for displaying and managing close/complete assignment dialog.
 */

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { STRINGS, VARIANTS, BUTTON_COLORS } from "../../../common/constants/commonConstants.js";
import { ASSIGNMENT_STRINGS, ASSIGNMENT_ACTIONS } from "../../../common/constants/ivrModule/assignmentConstants.js";

const CloseCompleteAssignmentDialog = ({ open, action, message, validAssignments, onConfirm, onClose }) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>
                {action === ASSIGNMENT_ACTIONS.COMPLETE ? ASSIGNMENT_STRINGS.CONFIRM_COMPLETE : ASSIGNMENT_STRINGS.CONFIRM_CLOSE}
            </DialogTitle>
            <DialogContent>
                {message}
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    variant={VARIANTS.CONTAINED}
                    color={BUTTON_COLORS.PRIMARY}
                >
                    {STRINGS.CLOSE}
                </Button>
                {validAssignments > 0 && (
                    <Button
                        onClick={onConfirm}
                        variant={VARIANTS.CONTAINED}
                        color={action === ASSIGNMENT_ACTIONS.COMPLETE ? BUTTON_COLORS.SUCCESS : BUTTON_COLORS.ERROR}
                    >
                        {STRINGS.CONFIRM}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default CloseCompleteAssignmentDialog;